export default __webpack_public_path__ + "static/media/background.05e174d1.jpg";